import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzRestartEndpointWebComponent } from './component/GzRestartEndpointWebComponent';
import { translateFn } from '../../../../utils/translator.helper';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';

export class RestartTaskPopUp extends NetworkBasePopUp<GzRestartEndpointWebComponent> {
  protected title = translateFn('Restart endpoint');
  protected extraDialogConfigs = { isWindow: true };
  protected transformToTaskTarget = true;

  protected customSetup() {
    this.popUpContent = new GzRestartEndpointWebComponent();

    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        label: translateFn('Restart'),
      },
      {
        id: 'closeButton',
        label: translateFn('Cancel'),
      },
    ];
  }

  protected async handleConfirmButtonClicked(event: CustomEvent) {
    if (!this.data.targets || this.data.targets.length === 0) {
      console.error('Could not start task due to empty targets.');
      return;
    }

    const payload = this.popUpContent.getFormValue();
    const createTaskRequest: CreateTaskRequest = {
      settings: {
        specifics: payload,
        targets: this.data.targets,
        type: Constants.Tasks.Endpoints.TASK_TYPE_RESTART_ENDPOINT_PARENT,
        taskName: translateFn('Restart Client') + ' ' + getFormattedDateForTask(),
      },
    };

    return this.createTask(createTaskRequest);
  }
}
